<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import type { VariantProps } from 'tailwind-variants';
	import { tv } from '../tv';
	import { CONTAINER_COLOR_VARIANTS, RADII_VARIANTS } from '../variants';

	export const tooltipVariants = tv({
		base: 'inline-flex animate-rise-2 items-center border-b300 border-solid border-(--v-container-line) bg-(--v-container) px-s300 py-[0.375rem] text-(--v-on-container) shadow-e200',
		variants: { variant: CONTAINER_COLOR_VARIANTS, radii: RADII_VARIANTS },
		defaultVariants: { variant: 'Surface', radii: '400' }
	});

	export interface TooltipProps
		extends Omit<HTMLAttributes<HTMLElement>, 'class'>, VariantProps<typeof tooltipVariants> {
		as?: string;
		children?: Snippet;
		class?: ClassValue;
		ref?: HTMLElement | null;
	}
</script>

<script lang="ts">
	let {
		as = 'div',
		children,
		class: className,
		radii,
		ref = $bindable(null),
		variant,
		...rest
	}: TooltipProps = $props();
</script>

<svelte:element
	this={as}
	bind:this={ref}
	class={[tooltipVariants({ radii, variant }), className]}
	{...rest}
>
	{@render children?.()}
</svelte:element>
